import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import styled from 'styled-components';

import amplitude from 'amplitude-js';
import { toggleModal, toggleSpinner } from 'apps/auth/actions/appAction';
import { toggleChat } from 'apps/auth/actions/chatAction';
import { addExtras, updateExtraByName } from 'apps/auth/actions/extraAction';
import { setCheque } from 'apps/auth/actions/historyAction';
import { updatePageMessages } from 'apps/auth/actions/messageAction';
import { sendGtEvent } from 'apps/auth/analytics/analytics';
import { PLACEMENT_ID, sendBrazeEvent } from 'apps/auth/analytics/braze';
import BrazeBannerPlacement from 'apps/auth/components/braze/BrazeBannerPlacement';
import { Button } from 'apps/auth/components/common/Button/Button';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { MainColumn } from 'apps/auth/components/common/Layout/MainColumn/MainColumn';
import { BlockSubheader, FeaturesBlock, FeaturesList, FeaturesListItem, IntroBlock, IntroBlockImg } from 'apps/auth/components/common/Layout/MainColumn/styles';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { SelectCountryScreenPureComponent } from 'apps/auth/components/common/search/SelectCountryScreen';
import { Text } from 'apps/auth/components/common/Text/Text';
import DetailsModal from 'apps/auth/components/history/DetailsModal';
import HistorySpinner from 'apps/auth/components/history/HistorySpinner';
import Notification from 'apps/auth/components/history/Notification';
import Balance from 'apps/auth/components/history/send/balance/Balance';
import EmptyTransfers from 'apps/auth/components/history/send/emptyTransfers/EmptyTransfers';
import ChooseWhoToSendPopup from 'apps/auth/components/history/send/popup/ChooseWhoToSendPopup';
import TrustpilotRatePopup from 'apps/auth/components/history/send/popup/TrustpilotRatePopup';
import SendHistory from 'apps/auth/components/history/send/SendHistory';
import { SeparateLayout } from 'apps/auth/components/history/send/separateLayout/SeparateLayout';
import TermsDisclaimer from 'apps/auth/components/history/send/TermsDisclaimer';
import PaysendPlusBanner from 'apps/auth/components/paysendPlus/PaysendPlusBanner';
import HalloweenCampaignBanner from 'apps/auth/components/send/banners/HalloweenBanner';
import MgmCampaignBanner from 'apps/auth/components/send/banners/MgmCampaignBanner';
import Sun25PromoCampaignBanner from 'apps/auth/components/send/banners/Sun25PromoCampaignBanner';
import FirstTimeTransferStories from 'apps/auth/components/send/FirstTimeTransferStories/FirstTimeTransferStories';
import EmptyScreen from 'apps/auth/components/send/UsToLacPromo/EmptyScreen';
import UsToLacPromo from 'apps/auth/components/send/UsToLacPromo/UsToLacPromo';
import { getTransferCountParam } from 'apps/auth/components/utils/AmplitudeUtils';
import BasePageWithLeftMenu from 'apps/auth/components/utils/BasePageWithLeftMenu';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import ModalNew from 'apps/auth/components/utils/ModalNew';
import { NOT_NOW_CLICKED, ONBOARDING_COMPLETED, SEND_MONEY_BUTTON_CLICKED, SPECIAL_OFFER_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { SCREEN, IS_LOW_RISK, PAYMENT_COUNTRY, PAYOUT_COUNTRY, TRANSFER_COUNT, UI_LANGUAGE, FROM } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { MAIN, PROMO } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { BR_NEW_TRANSFER_START, BR_REG_SEND_COUNTRY_TO_SELECTED } from 'apps/auth/constants/braze/brazeEvents';
import { BRAZE_IAM_PLACEMENTS, BRAZE_IAM_SCREEN_EVENTS } from 'apps/auth/constants/braze/brazeIam';
import { BR_COUNTRY } from 'apps/auth/constants/braze/brazeParams';
import { SEND, USA_TO_LAC_SELECTED_COUNTRY } from 'apps/auth/constants/Constants';
import { IS_NEW_USER } from 'apps/auth/constants/ExtraNames';
import { GA4_SIGN_UP, GT_LOGIN_SUCCESS, GT_REG_SUCCESS } from 'apps/auth/constants/GoogleAnalyticsEvents';
import { GT_USER_ID } from 'apps/auth/constants/GoogleAnalyticsParamNames';
import { AUTH_SEND, AUTH_SEND_LINK, URL_CLOUD, URL_VIDEOS, URL_WELCOME_SCREEN_IMG } from 'apps/auth/constants/UrlConstants';
import { UTM_PARAM_NAMES } from 'apps/auth/constants/utmParams';
import { apiFetchData } from 'apps/auth/helpers/api';
import { toLowerCase } from 'apps/auth/helpers/utils';
import { useApp, useAuth, useCheck, useExtra, useHistoryRecords, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';
import { useThemeDetector } from 'apps/auth/hooks/theme';
import { useBrazeIamScreen } from 'apps/auth/hooks/useBrazeIamScreen';
import { usePrefersReducedMotion } from 'apps/auth/hooks/usePrefersReducedMotion';
import MgmPromoStories from 'apps/auth/pages/profile/inviteFriend/MgmPromoStories';
import ShareInvitationLinkPopup from 'apps/auth/pages/profile/inviteFriend/ShareInvitationLinkPopup';
import { GTRestrictionService } from 'apps/auth/services/GTRestrictionService';
import { showPromoModal } from 'apps/auth/services/promoModalService';
import media from 'apps/auth/theme/media';
import Cookies from 'universal-cookie';

const ContentContainer = styled.div`
    max-width: 480px;
    margin: 0 auto;

    ${media.tablet720} {
        max-width: 888px;
        padding: 0 24px;
    }
`;

const SendMainPage = (props) => {
    const gtRestrictionService = useRef(null);
    const location = useLocation();
    const messages = usePageMessages();
    const extra = useExtra();
    const { ballId, canSendMoney, lowRisk } = useAuth();
    const { isShowCustomSpinner } = useApp();
    const { lang } = useLanguage();
    const cheque = useCheck();
    const payments = useHistoryRecords();
    const popupRef = useRef(null);
    const popupFullwidthRef = useRef(null);
    const modalRef = useRef(null);
    const heroVideoRef = useRef(null);
    const sendUrIPrefix = AUTH_SEND_LINK;

    const [pageNumber, setPageNumber] = useState(0);
    const [isBrazeBannerVisible, setIsBrazeBannerVisible] = useState(false);
    const [selectedLacCountry, setSelectedLacCountry] = useState(() => {
        if (typeof window !== 'undefined') {
            const cookies = new Cookies();
            return cookies.get(USA_TO_LAC_SELECTED_COUNTRY) || null;
        }
        return null;
    });

    const { theme } = useThemeDetector();
    const prefersReducedMotion = usePrefersReducedMotion();

    useBrazeIamScreen(BRAZE_IAM_SCREEN_EVENTS.MAIN_SCREEN, BRAZE_IAM_PLACEMENTS.MAIN_SCREEN);

    const notNowButtonClick = () => {
        popupFullwidthRef?.current?.close();
    };

    const getActiveBanner = () => {
        if (isBrazeBannerVisible) return null;
        if (extra.paysendPlusBannerEnabled) return 'PLUS'; // 1-й приоритет
        if (extra.showBannerSun25Enabled) return 'SUN25'; // 2-й
        if (extra.showBannerHalloween25Enabled) return 'HALLOWEEN'; // 3-й
        if (extra.showMgmPromoBannerEnabled) return 'MGM'; // 4-й
        return null; // ничего не показываем
    };

    const activeBanner = getActiveBanner();

    const inviteButtonClick = () => {
        const { shareLinkText, shareInvitationLinkButton, trackReferralsButton } = messages;
        popupRef.current?.open(
            <ShareInvitationLinkPopup
                popupRef={popupRef}
                text={shareLinkText}
                shareInvitationLinkButton={shareInvitationLinkButton}
                trackReferralsButton={trackReferralsButton}
            />,
        );
    };

    useEffect(() => {
        gtRestrictionService.current = new GTRestrictionService(messages, popupRef);
        gtRestrictionService.current.setActions(props.toggleModal, props.toggleSpinner);
        gtRestrictionService.current.setExtra(extra);
    }, [extra, messages, props.toggleModal, props.toggleSpinner]);

    useEffect(() => {
        const cookies = new Cookies();
        UTM_PARAM_NAMES.forEach((name) => cookies.remove(name, { path: '/' }));
        amplitude.getInstance().setUserProperties({ balId: ballId, [UI_LANGUAGE]: lang, [IS_LOW_RISK]: lowRisk });
        amplitude.getInstance().logEvent('Transfer Main Screen Shown');
        if (location.search === '?login=completed') {
            sendGtEvent(GT_LOGIN_SUCCESS, { [GT_USER_ID]: ballId });
        } else if (location.search === '?registration=completed') {
            sendGtEvent(GT_REG_SUCCESS, { [GT_USER_ID]: ballId });
        }
    }, []);

    useEffect(() => {
        if (!!extra.isNewUser) {
            amplitude.getInstance().logEvent(ONBOARDING_COMPLETED);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: GA4_SIGN_UP });
            props.updateExtraByName(IS_NEW_USER, false);
        }
    }, [extra.isNewUser]);

    useEffect(() => {
        if (!cheque && extra.cheque) {
            props.setCheque(extra.cheque);
        }
        if (cheque && !extra.incompleteTransfer) {
            props.toggleModal(true, <DetailsModal isSend={true} />);
        }
    }, [cheque, extra.cheque]);

    useEffect(() => {
        if (extra.isShowTermsPlc) {
            props.toggleModal(
                true,
                <TermsDisclaimer
                    continueButton={messages.continueButton}
                    userName={extra.userName}
                    userLastName={extra.userLastName}
                    title={messages.termsPlcTitle}
                    content={messages.termsPlcText}
                />,
            );
        }
    }, [extra.isShowTermsPlc]);

    useEffect(() => {
        if (extra.showTrustpilotPopup) {
            amplitude.getInstance().logEvent('Review Paysend Banner Shown');
            popupRef.current?.open(
                <TrustpilotRatePopup
                    buttonTitle={messages.trustpilotPopupButton}
                    info={<DangerouslyHtml dangerouslyHtml={messages.trustpilotPopupText} />}
                    href={extra.trustpilotHref}
                    popupRef={popupRef}
                />,
            );
        }
    }, [extra.showTrustpilotPopup]);

    useEffect(() => {
        if (extra.showRecipientTypePopup && !extra.chooseWhoToSendPopup) {
            popupRef.current?.open(<ChooseWhoToSendPopup uri={AUTH_SEND_LINK} popupRef={popupRef} />);
        }
    }, [extra.showRecipientTypePopup]);

    useEffect(() => {
        const showFirstTransferModal = showPromoModal(ballId, extra.firstTransferPromoSliders, 'first_time_transfer_info');
        if (showFirstTransferModal) {
            popupFullwidthRef.current?.open(
                <FirstTimeTransferStories
                    sliders={extra.firstTransferPromoSliders}
                    popupFullwidthRef={popupFullwidthRef}
                    checkRestrictions={(e) => gtRestrictionService.current.checkRestrictions(e)}
                    hasTopButton={extra.firstTransferPromoSliders?.not_now}
                />,
            );
        }
        const showMgmModal = showPromoModal(ballId, extra.mgmPromoSlider, 'mgm_info');
        if (showMgmModal) {
            popupFullwidthRef.current?.open(
                <MgmPromoStories sliders={extra.mgmPromoSlider} onTopButtonClick={notNowButtonClick} onBottomButtonClick={inviteButtonClick} />,
            );
        }
    }, [ballId, extra.firstTransferPromoSliders, extra.mgmPromoSlider, extra.showMgmPromoSlider]);

    const replayHeroVideo = () => {
        const video = heroVideoRef.current;
        if (video) {
            video.currentTime = 0;
            video.play?.();
        }
    };

    const onCountryItemClick = (e, toCountry) => {
        e.preventDefault();
        const cookies = new Cookies();
        const expiredDate = new Date();
        expiredDate.setFullYear(expiredDate.getFullYear() + 1);
        cookies.set(USA_TO_LAC_SELECTED_COUNTRY, toCountry.code, { path: '/', expires: expiredDate });
        setSelectedLacCountry(toCountry.code);

        if (extra?.listOfLacCountries.includes(toCountry.code)) {
            props.toggleSpinner(true);
            apiFetchData(`/auth/usa-to-lac/get/rate/${toCountry.id}`)
                .then((json) => {
                    if (json?.extra?.lacPromoScreen) {
                        props.addExtras(json?.extra);
                        if (json.messages) {
                            props.updatePageMessages(json?.messages);
                        }
                        props.toggleSpinner(false);
                        popupFullwidthRef.current?.open(
                            <UsToLacPromo
                                promo={json?.extra?.lacPromoScreen}
                                popupFullwidthRef={popupFullwidthRef}
                                offerLacText={json.extra.lacRateStory}
                                onNotNowClick={() => {
                                    modalRef.current.close();
                                    amplitude.getInstance().logEvent(NOT_NOW_CLICKED, {
                                        [PAYOUT_COUNTRY]: toCountry?.nameEn,
                                        [PAYMENT_COUNTRY]: extra.userCountry?.nameEn,
                                        [FROM]: PROMO,
                                    });
                                    popupFullwidthRef.current?.close();
                                    replayHeroVideo();
                                }}
                                onSendClick={() => {
                                    modalRef.current.close();
                                    popupFullwidthRef.current?.close();
                                    amplitude.getInstance().logEvent(SEND_MONEY_BUTTON_CLICKED);
                                    popupRef.current?.open(
                                        <ChooseWhoToSendPopup
                                            uri={`${AUTH_SEND}/${toLowerCase(toCountry?.code)}/delivery`}
                                            popupRef={popupRef}
                                            hideToBusinessRecipient={true}
                                        />,
                                    );
                                }}
                                onBackButtonClick={() => {
                                    popupFullwidthRef.current?.close();
                                }}
                            />,
                        );
                    }
                })
                .finally(() => {
                    props.toggleSpinner(false);
                });
        } else {
            modalRef.current.close();
            replayHeroVideo();
        }
    };

    const sendEventOnCountrySelect = (country) => {
        sendBrazeEvent(BR_REG_SEND_COUNTRY_TO_SELECTED, { [BR_COUNTRY]: country?.id?.toString() });
    };
    const openLacCountrySelectModal = (clickOnRate) => {
        if (clickOnRate) {
            amplitude.getInstance().logEvent(SPECIAL_OFFER_CLICKED, { [SCREEN]: MAIN });
        }
        modalRef.current?.open(
            <SelectCountryScreenPureComponent
                countries={extra.preselectCountriesTo}
                userCountry={extra.userCountry}
                gotIt={messages.gotIt}
                title={messages.usaToLacTitleForCountries}
                onCountryItemClick={onCountryItemClick}
                sendUrIPrefix={sendUrIPrefix}
                searchPlaceholder={messages.searchPlaceholder}
                fullScreenSearchPlaceholder={messages.searchByCountryPlaceholder}
                searchNoResult={messages.searchNoResults}
                isShowSuggestedCountries={true}
                quantityCountriesForRender={5}
                showCurrency={true}
                canCloseModal={false}
                sendBrazeEvent={sendEventOnCountrySelect}
            />,
        );
    };

    useEffect(() => {
        if (extra.showUSAtoLACPromoCampaignSelectCountryScreen) {
            openLacCountrySelectModal();
        }
    }, [extra.showUSAtoLACPromoCampaignSelectCountryScreen]);

    useEffect(() => {
        if (extra.showPreparedPs3MigrationScreen) {
            togglePs3MigrationModal();
        }
    }, [extra.showPreparedPs3MigrationScreen]);

    const hasPayments = (payments && payments.payments.length > 0) || extra.incompletePayment || extra.awaitingPayment;

    const onSend = (e) => {
        sendBrazeEvent(BR_NEW_TRANSFER_START);
        amplitudeEventForSendMoneyButtonClick();
        gtRestrictionService.current?.checkRestrictions(e);
    };

    const amplitudeEventForSendMoneyButtonClick = () => {
        const transferCount = getTransferCountParam();
        amplitude.getInstance().logEvent(SEND_MONEY_BUTTON_CLICKED, { [TRANSFER_COUNT]: transferCount });
    };

    const togglePs3MigrationModal = () => {
        props.toggleModal(
            true,
            <ModalComponent isVerticalCentered canCloseModal={false}>
                <InfoPage
                    insideModalComponent
                    iconName="clock-80"
                    iconColor="primary"
                    primaryButtonCaption={extra.showMigrationChat ? messages?.contactSupport : messages?.gotIt}
                    headerText={messages?.preparingBetaTitle}
                    secondaryText={<DangerouslyHtml dangerouslyHtml={messages?.preparingBetaSubtitle} />}
                    primaryButtonOnClick={(e) => {
                        e.preventDefault();
                        if (extra.showMigrationChat) {
                            props.toggleChat(true);
                        } else {
                            props.toggleModal(false);
                        }
                    }}
                />
            </ModalComponent>,
        );
    };

    const incrementPage = () => {
        setPageNumber(pageNumber + 1);
    };

    const sendMoneyButton = () => {
        return (
            <FixedBottomPanel isPressedAboveMenu isRightAligned fullwidth={!extra.showNewMainScreen} isNewMainScreen={extra.showNewMainScreen}>
                <Button
                    type="link"
                    raised={true}
                    href={AUTH_SEND_LINK}
                    onClick={onSend}
                    data-testid="send-main-link-new-send"
                    caption={messages.newTransaction}
                />
            </FixedBottomPanel>
        );
    };

    const getEmptyScreen = () => {
        const heroTheme = theme === 'dark' ? 'dark' : 'light';
        const heroPoster = `${URL_WELCOME_SCREEN_IMG}/welcome-placeholder-blue-${heroTheme}.webp`;
        // TODO: temporary — always show the static logo until the updated video logo is delivered.
        const isImageLogo = true;
        const heroLogo = (
            <IntroBlockImg>
                {isImageLogo || prefersReducedMotion ? (
                    <img src={heroPoster} alt="Paysend" />
                ) : (
                    <video ref={heroVideoRef} autoPlay muted playsInline preload="auto" poster={heroPoster} aria-label="Paysend">
                        <source src={`${URL_VIDEOS}/paysend-${heroTheme}-hero.mp4`} type="video/mp4" />
                    </video>
                )}
            </IntroBlockImg>
        );

        if (extra?.listOfLacCountries && selectedLacCountry && extra?.listOfLacCountries.includes(selectedLacCountry)) {
            return (
                <>
                    <IntroBlock>
                        <EmptyScreen
                            emptyImage={`${URL_CLOUD}/promo_fee_countries_new/empty_screen/${selectedLacCountry}/${selectedLacCountry}_home${theme === 'dark' ? '_dark' : '_light'}.svg`}
                            fallback={heroLogo}
                            text={messages[`${selectedLacCountry}EmptyScreenLacText`]}
                            onRateClick={() => {
                                openLacCountrySelectModal(true);
                            }}
                            rateText={<DangerouslyHtml dangerouslyHtml={extra.lacRateEmptyScreen} />}
                        />
                    </IntroBlock>
                    {extra.featuresLacArray?.length > 0 && (
                        <>
                            <Separator />
                            <FeaturesBlock>
                                <BlockSubheader>{messages.specialLacHeader}</BlockSubheader>
                                <FeaturesList>
                                    {extra.featuresLacArray.map((item, i) => (
                                        <FeaturesListItem key={item + i}>
                                            <Icon name="check" color="primary" rightIndent="16px" />
                                            <span>{item}</span>
                                        </FeaturesListItem>
                                    ))}
                                </FeaturesList>
                            </FeaturesBlock>
                        </>
                    )}
                    {extra?.featuresLacArray === undefined && featuresArray.length > 0 && (
                        <>
                            <Separator />
                            <FeaturesBlock>
                                <BlockSubheader>{messages.featuresTitle}</BlockSubheader>
                                {featuresList}
                            </FeaturesBlock>
                        </>
                    )}
                </>
            );
        }

        return (
            <>
                <IntroBlock>
                    {heroLogo}
                    {!canSendMoney ? <Text size={'main'}>{messages.waitingListTitle}</Text> : <Text size={'main'}>{messages.historyTitle}</Text>}
                </IntroBlock>
                {featuresArray.length > 0 && (
                    <>
                        <Separator />
                        <FeaturesBlock>
                            <BlockSubheader>{messages.featuresTitle}</BlockSubheader>
                            {featuresList}
                        </FeaturesBlock>
                    </>
                )}
            </>
        );
    };

    let featuresArray = [
        messages.featuresSendTitleSection0,
        messages.featuresSendTitleSection1,
        messages.featuresSendTitleSection2,
        messages.featuresSendTitleSection3,
        messages.featuresSendTitleSection4,
        messages.featuresSendTitleSection5,
    ].filter(function (e) {
        return e;
    });

    let featuresList = (
        <FeaturesList>
            {featuresArray.map((item, i) => (
                <FeaturesListItem key={item + i}>
                    <Icon name="check" color="primary" rightIndent="16px" />
                    <span>{item}</span>
                </FeaturesListItem>
            ))}
        </FeaturesList>
    );
    let content;
    if (hasPayments) {
        content = (
            <>
                <HeaderPanel title={messages.headerTitle} />
                <Row flex justify="center" indent="48px">
                    <BrazeBannerPlacement placementId={PLACEMENT_ID} onVisibilityChange={setIsBrazeBannerVisible} />
                </Row>
                {activeBanner === 'PLUS' && (
                    <Row flex justify="center" indent="48px">
                        <PaysendPlusBanner updateExtraByName={props.updateExtraByName} paysendPlusBannerEnabled={extra.paysendPlusBannerEnabled} />
                    </Row>
                )}

                {activeBanner === 'MGM' && (
                    <Row flex justify="center" indent="48px">
                        <MgmCampaignBanner updateExtraByName={props.updateExtraByName} />
                    </Row>
                )}

                {activeBanner === 'SUN25' && (
                    <Row flex justify="center" indent="48px">
                        <Sun25PromoCampaignBanner updateExtraByName={props.updateExtraByName} />
                    </Row>
                )}

                {activeBanner === 'HALLOWEEN' && (
                    <Row flex justify="center" indent="48px">
                        <HalloweenCampaignBanner updateExtraByName={props.updateExtraByName} />
                    </Row>
                )}

                {!props.loading && <SendHistory popupRef={popupRef} modalRef={modalRef} />}
                {isShowCustomSpinner && <HistorySpinner />}
                {canSendMoney && sendMoneyButton()}
            </>
        );
    } else {
        content = (
            <>
                <Row flex justify="center" indent="48px">
                    <BrazeBannerPlacement placementId={PLACEMENT_ID} onVisibilityChange={setIsBrazeBannerVisible} />
                </Row>
                {activeBanner === 'PLUS' && (
                    <Row flex justify="center" indent="48px">
                        <PaysendPlusBanner updateExtraByName={props.updateExtraByName} paysendPlusBannerEnabled={extra.paysendPlusBannerEnabled} />
                    </Row>
                )}

                {activeBanner === 'MGM' && (
                    <Row flex justify="center" indent="48px">
                        <MgmCampaignBanner updateExtraByName={props.updateExtraByName} />
                    </Row>
                )}

                {activeBanner === 'SUN25' && (
                    <Row flex justify="center" indent="48px">
                        <Sun25PromoCampaignBanner updateExtraByName={props.updateExtraByName} />
                    </Row>
                )}

                {activeBanner === 'HALLOWEEN' && (
                    <Row flex justify="center" indent="48px">
                        <HalloweenCampaignBanner updateExtraByName={props.updateExtraByName} />
                    </Row>
                )}

                {getEmptyScreen()}
                {messages.historyUsaOfferInfo && (
                    <Row direction="column" flex>
                        <Text>{messages.historyUsaOfferInfo}</Text>
                    </Row>
                )}
                {canSendMoney && sendMoneyButton()}
            </>
        );
    }

    const passkeyDbSetupLog = extra?.passkeyDbSetupLog;

    let result;
    if (extra.showPreparedPs3MigrationScreen) {
        result = <></>;
    } else {
        result = (
            <>
                {passkeyDbSetupLog && passkeyDbSetupLog.length > 0 && (
                    <div
                        style={{
                            background: '#1a1a2e',
                            color: '#e0e0e0',
                            fontFamily: 'monospace',
                            fontSize: '12px',
                            padding: '12px 16px',
                            margin: '0 0 8px 0',
                            borderLeft: '4px solid #7b61ff',
                            borderRadius: '4px',
                        }}
                    >
                        <div style={{ color: '#7b61ff', fontWeight: 'bold', marginBottom: '6px' }}>[DEBUG] Passkey DB Setup</div>
                        {passkeyDbSetupLog.map((line, i) => {
                            let color = '#e0e0e0';
                            if (line.startsWith('[ERROR]')) {
                                color = '#ff6b6b';
                            } else if (line.startsWith('[OK]')) {
                                color = '#6bffb8';
                            } else if (line.startsWith('[SKIP]')) {
                                color = '#aaa';
                            }
                            return (
                                <div key={i} style={{ color, lineHeight: '1.6' }}>
                                    {line}
                                </div>
                            );
                        })}
                    </div>
                )}
                {extra.showNewMainScreen ? (
                    <SeparateLayout topComponent={<Balance />} onScrollEnd={() => incrementPage()}>
                        <ContentContainer>
                            {hasPayments ? (
                                <>
                                    {!props.loading && <SendHistory popupRef={popupRef} modalRef={modalRef} pageNumber={pageNumber} isNewMainScreen />}
                                    {isShowCustomSpinner && <HistorySpinner />}
                                </>
                            ) : (
                                <EmptyTransfers />
                            )}
                        </ContentContainer>
                        {canSendMoney && sendMoneyButton()}
                    </SeparateLayout>
                ) : (
                    <MainColumn>
                        <Notification modalRef={modalRef} />
                        {content}
                    </MainColumn>
                )}
                <PopupNew ref={popupRef} overflowHidden={extra.incompleteTransfer} />
                <PopupNew ref={popupFullwidthRef} fullwidthPopup />
                <ModalNew ref={modalRef} />
            </>
        );
    }

    return result;
};

export default connect(null, {
    toggleSpinner,
    toggleChat,
    toggleModal,
    updateExtraByName,
    setCheque,
    addExtras,
    updatePageMessages,
})(BasePageWithLeftMenu(SendMainPage, SEND));
